import { PopoverProps } from '@arco-design/web-react';
import React, { useCallback, useMemo } from 'react';
import { IconFont } from '@bay-email/editor';
import { ToolItem } from '../ToolItem';
import { useTiptapEditor } from '../Tools/TiptapEditorContext';
import { EMAIL_BLOCK_CLASS_NAME } from '@bay-email/core';

export interface LinkProps extends PopoverProps {
	currentRange: Range | null | undefined;
	onChange: () => void;
}

function getStrikeThroughNode(node: Node | null | undefined): Element | null {
	if (!node) return null;
	if (node instanceof Element && node.classList.contains(EMAIL_BLOCK_CLASS_NAME))
		return null;
	if (node instanceof Element && node.tagName.toLocaleLowerCase() === 'strike')
		return node;
	return getStrikeThroughNode(node.parentNode);
}

export function StrikeThrough(props: LinkProps) {
	const { onChange } = props;
	const editor = useTiptapEditor();
	const node = useMemo(() => {
		return getStrikeThroughNode(props.currentRange?.commonAncestorContainer);
	}, [props.currentRange]);

	const onClick = useCallback(() => {
		// Don't change the selection - just apply the formatting
		onChange();
	}, [onChange]);

	return (
		<ToolItem
			title={t('Strikethrough')}
			isActive={editor ? editor.isActive('strike') : Boolean(node)}
			icon={<IconFont iconName='icon-strikethrough' />}
			onClick={onClick}
		/>
	);
}
